import { useApiClient } from '@/api/client'

import { GetPaymentsAppointmentDetailsResponseSchema } from '../types'

import type { GetPaymentsAppointmentDetailsResponse } from '../types'

export const GET_PAYMENTS_APPOINTMENT_DETAILS = '/core/v2/business_api/me/businesses/{businessId}/payments/appointments/{appointmentId}/details/'

export type GetPaymentsAppointmentDetailsOptions = {
  businessId: number | string
  appointmentId: number | string
}

export const getPaymentsAppointmentDetails = (
  options: GetPaymentsAppointmentDetailsOptions
): Promise<GetPaymentsAppointmentDetailsResponse> => {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_PAYMENTS_APPOINTMENT_DETAILS,
    urlParams: {
      businessId: options.businessId,
      appointmentId: options.appointmentId,
    },
  })
    .then(({ data }) => GetPaymentsAppointmentDetailsResponseSchema.parse(data))
}
